<template>
	<div>
		<headTip></headTip>
		<userHead></userHead>
		<div class="userInfo">
			<div class="userInfo_left">
				<userLeft></userLeft>
			</div>
			<div class="userInfo_right">
				<router-view></router-view>
			</div>
			<userQrcode></userQrcode>
		</div>
		<footerTip></footerTip>
	</div>
</template>

<script>
	import headTip from '../../components/headTip.vue'
	import userQrcode from '../../components/userQrcode.vue'

	import userLeft from './components/userLeft.vue'
	import footerTip from '../../components/footerTip.vue'
	import userHead from './components/userHead.vue'
	export default {
		components: {
			headTip,
			footerTip,
			userHead,
			userLeft,
			userQrcode
		},
	}
</script>

<style scoped>
	.userInfo {
		width: 1200px;
		margin: -30px auto 0;
		min-height: 710px;

		display: flex;
		justify-content: space-between;
	}

	.userInfo_left {
		width: 280px;
		/* height: 710px; */
	}

	.userInfo_right {
		width: calc(100% - 300px);
		z-index: 2;
		/* height: 710px; */
	}
	.addIframeWidth{
		margin: 0 !important;
	}
</style>